import { useTranslation } from "react-i18next";
import Grid from "@mui/material/Grid";
import Paper from "@mui/material/Paper";
import type { PlatformBlockComponent } from "../../../types";
import { BlockFormHeader } from "../BlockFormHeader";
import { TextField } from "@/shared/components/Form/TextField";
import { AutocompleteField } from "@/shared/components/Form/AutocompleteField";
import { Switch } from "@/shared/components/Form/Switch";
import { ItemsPerRowField } from "../../ItemsPerRowField";

const viewValues = ["CAROUSEL", "GRID"] as const;

const previewModeValues = ["HORIZONTAL", "VERTICAL"] as const;

// TagsSort сайтовой схемы: MANUAL это сначала избранные, затем по названию
const sortValues = ["TITLE", "LATEST", "MANUAL"] as const;

export const Tags: PlatformBlockComponent = ({ name, platformId, queries }) => {
  const { t } = useTranslation();

  const viewOptions = viewValues.map((value) => ({
    value,
    label: t(`platformBlocks.view.${value}`),
  }));

  const previewModeOptions = previewModeValues.map((value) => ({
    value,
    label: t(`platformBlocks.previewMode.${value}`),
  }));

  const sortOptions = sortValues.map((value) => ({
    value,
    label: t(`platformBlocks.sort.${value}`),
  }));

  return (
    <Paper sx={{ p: 2 }}>
      <BlockFormHeader blockType="TAGS" />
      <Grid container spacing={2}>
        <Grid size={12}>
          <TextField
            name={`${name}.title`}
            label={t("platformBlocks.fields.title")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <AutocompleteField
            name={`${name}.view`}
            label={t("platformBlocks.fields.view")}
            fullWidth
            options={viewOptions}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <AutocompleteField
            name={`${name}.previewMode`}
            label={t("platformBlocks.fields.previewMode")}
            fullWidth
            options={previewModeOptions}
          />
        </Grid>
        <Grid size={12}>
          <AutocompleteField
            multiple
            name={`${name}.typeIds`}
            label={t("platformBlocks.fields.tagTypes")}
            fullWidth
            query={queries?.autocompleteTagTypes}
            queryVariables={platformId ? { filter: {} } : undefined}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <ItemsPerRowField
            name={`${name}.itemsPerRow`}
            label={t("platformBlocks.fields.itemsPerRow")}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <TextField
            name={`${name}.limit`}
            label={t("platformBlocks.fields.limit")}
            type="number"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 4 }}>
          <AutocompleteField
            name={`${name}.sort`}
            label={t("platformBlocks.fields.sort")}
            fullWidth
            options={sortOptions}
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            name={`${name}.moreUrl`}
            label={t("platformBlocks.fields.moreUrl")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={{ xs: 12, sm: 6 }}>
          <TextField
            name={`${name}.moreText`}
            label={t("platformBlocks.fields.moreText")}
            type="text"
            fullWidth
          />
        </Grid>
        <Grid size={12}>
          <Switch
            name={`${name}.noMore`}
            label={t("platformBlocks.fields.hideShowAll")}
          />
        </Grid>
      </Grid>
    </Paper>
  );
};
